import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import { TgglClient, type TgglContext, type TgglFlags } from 'tggl-client'

import type {
  FeatureFlagContext,
  FeatureFlags,
} from 'types/common/featureFlag/featureFlag'

export const useFeatureFlagStore = defineStore('featureFlag', () => {
  // CONTEXT
  const client = ref<null | TgglClient<TgglFlags, TgglContext>>(null)

  const init = () => {
    client.value = new TgglClient(process.env.TGGL_CLIENT_KEY, {
      reporting: false,
    })
  }

  const updateWatcher = (context: () => FeatureFlagContext | undefined) => {
    watch(
      context,
      async (val) => {
        if (val) {
          await client.value?.setContext(val)
        } else {
          await client.value?.setContext({
            current_hour: new Date().getUTCHours().toString(),
          })
        }
      },
      { immediate: true }
    )
  }

  // FLAGS
  const isActive = (flag: keyof FeatureFlags) => {
    // Return true if in development mode
    if (process.env.DEV) {
      return true
    } else {
      if (!client.value) return false

      return client.value.isActive(flag) ? client.value.get(flag) : false
    }
  }

  // STORE RESET
  // Used to reset the store (is given by default by pinia on options api stores but not on composition api stores)
  const $reset = () => {
    client.value = null
  }

  return {
    client,
    init,
    updateWatcher,
    isActive,
    $reset,
  }
})
